import React, { useEffect, useState } from 'react';
import { SubHeader } from '../../../utils/componentes-utiles/SubHeader';
import { CircularProgress, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Checkbox, Paper, Grid, Typography } from '@mui/material';
import { getRolesYDepartamentos } from '../../../services/apis';
import { PermisosOpciones } from './PermisosOpciones';

export const RolesYDepartamentos = () => {
    const [opciones, setOpciones] = useState([]);
    const [loaded, setLoaded] = useState(false);
    const [roles, setRoles] = useState([]);

    const cargarOpciones = async () => {

        try {
            const response = await getRolesYDepartamentos();

            console.log('Opciones cargadas:', response.data);
            
            setOpciones(response.data.opciones);
            setRoles(response.data.roles);
            setLoaded(true);
        } catch (error) {
            console.error('Error al cargar las opciones:', error);
        }
    };

    useEffect(() => {
        cargarOpciones();
    }, []);



    return (
        <Grid container
                size={{ xs: 12 }}
                sx={{ justifyContent: 'center' }}>
            <SubHeader titulo={'Roles y Departamentos'} />

            {!loaded && <CircularProgress />}
            {loaded && (
                <>
                    {opciones.map(opcion => (
                        <>
                            <PermisosOpciones roles={roles} opciones={opcion.opciones} title={opcion.nombre} nombreArray={opcion.url} />
                        </>
                    ))}
                </>
            )}
        </Grid>
    );
};
